module.exports = __webpack_public_path__ + "media/images/mission_bg_5-676440d6bbf8712ce9de644ccfaa4740.svg";